import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/hero-screenshot-1.webp")